import ServiceTemplate from '../ServiceTemplate';

const RefinanceMortgage = () => {
  const serviceData = {
    title: 'מחזור משכנתא',
    description: 'בדיקה מקיפה של תנאי המשכנתא הקיימת והצעת מסלול מחזור משתלם יותר עבורכם, תוך חיסכון משמעותי בעלויות.',
    sections: [
      {
        title: 'מתי כדאי למחזר משכנתא?',
        content: 'מחזור משכנתא יכול להיות כדאי במספר מקרים: כאשר חלה ירידה בריביות בשוק, כשיש שינוי במצב הכלכלי שלכם, או כשאתם רוצים לשנות את תנאי ההחזר. אנחנו נבצע בדיקה מקיפה של המשכנתא הקיימת ונבחן את הכדאיות של המחזור עבורכם.'
      },
      {
        title: 'איך התהליך עובד?',
        content: 'ראשית, נבצע ניתוח מעמיק של המשכנתא הקיימת שלכם. לאחר מכן, נבדוק את כל האפשרויות בשוק ונשווה בין ההצעות של הבנקים השונים. נבנה עבורכם תמהיל חדש שיביא לחיסכון מקסימלי, ונלווה אתכם בכל התהליך מול הבנק.'
      }
    ],
    benefits: [
      'חיסכון של עשרות עד מאות אלפי שקלים',
      'הקטנת ההחזר החודשי',
      'התאמת תנאי המשכנתא למצב הכלכלי הנוכחי',
      'אפשרות לקבלת הלוואה נוספת',
      'שיפור תנאי הריבית',
      'ליווי מקצועי לאורך כל התהליך'
    ],
    faqs: [
      {
        question: 'האם תמיד כדאי למחזר משכנתא?',
        answer: 'לא תמיד. מחזור משכנתא כרוך בעלויות שונות כמו עמלת פירעון מוקדם, אגרות ועוד. אנחנו נבצע בדיקת כדאיות מקיפה שתביא בחשבון את כל העלויות ונמליץ על מחזור רק אם הוא באמת משתלם עבורכם.'
      },
      {
        question: 'מה ההבדל בין מחזור בבנק הנוכחי למחזור בבנק אחר?',
        answer: 'מחזור בבנק הנוכחי יכול להיות פשוט יותר, אך לא תמיד משתלם. כיועצת עצמאית, אני יכולה להשוות בין כל הבנקים ולהשיג עבורכם את התנאים הטובים ביותר, גם אם זה אומר מעבר לבנק אחר.'
      },
      {
        question: 'האם יש קנס על מחזור משכנתא?',
        answer: 'כן, בדרך כלל יש עמלת פירעון מוקדם. גובה העמלה תלוי במספר גורמים כמו סוג המסלול, תקופת ההלוואה שנותרה ועוד. אנחנו נחשב את העלות המדויקת ונוודא שהחיסכון ממחזור המשכנתא גדול משמעותית מעלויות הפירעון המוקדם.'
      },
      {
        question: 'כמה זמן לוקח תהליך מחזור משכנתא?',
        answer: 'תהליך מחזור משכנתא אורך בממוצע בין שבועיים לחודש. הזמן המדויק תלוי בגורמים שונים כמו מהירות קבלת האישורים מהבנקים והמסמכים הנדרשים. אנחנו נלווה אתכם לאורך כל התהליך ונדאג שיתנהל ביעילות המרבית.'
      },
      {
        question: 'האם אפשר למחזר משכנתא יותר מפעם אחת?',
        answer: 'כן, אין מגבלה על מספר הפעמים שניתן למחזר משכנתא. עם זאת, חשוב לבחון את הכדאיות הכלכלית בכל פעם מחדש. אנחנו ממליצים לבצע בדיקת כדאיות למחזור משכנתא לפחות פעם בשנה או כאשר חלים שינויים משמעותיים בשוק.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת במחזור משכנתא ואשמח לשמוע פרטים נוספים.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default RefinanceMortgage; 